function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 58 58"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M55.981 54.5H2.019A2.02 2.02 0 010 52.481V20.5h58v31.981a2.02 2.02 0 01-2.019 2.019z",
  fill: "#74cbff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.019 11.5V5.519A2.02 2.02 0 0024 3.5H2.019A2.02 2.02 0 000 5.519V20.5h58v-6.981a2.02 2.02 0 00-2.019-2.019H26.019z",
  fill: "#6fb9da"
})));